__turbopack_context__.v({
  "mapImage": "StaticMap-module-scss-module__7h9qYW__mapImage",
  "showMapButton": "StaticMap-module-scss-module__7h9qYW__showMapButton",
  "staticMap": "StaticMap-module-scss-module__7h9qYW__staticMap",
});
